import React from "react";
import { useNavigate } from "react-router-dom";
import { controleNestedModalOverlayStyle, createDossierButtonStyle, eyebrowStyle, pageHeaderStyle } from "./bis/bisLayoutStyles";
import { useControleBis } from "./bis/useControleBis";
import { renderActiveDossier } from "./bis/views/ActiveDossierView";
import { renderControlePatientModal } from "./bis/views/ControlePatientModalView";
import { renderValidatePreProductionConfirmModal } from "./bis/views/ValidatePreProductionConfirmModalView";
import { ControleDialogs, PatientRowHoverStyle } from "./shared/components/ControleDialogs";
import { CreateDossierModal } from "./shared/components/DossierDialogs";
import { CHARTER_COLORS as theme } from "./shared/controleTheme";
import { backButtonStyle } from "./shared/styles/layoutStyles";

function BackToPlanningButton() {
    const navigate = useNavigate();
    return (
        <button
            type="button"
            onClick={() => navigate("/robot-planning")}
            style={backButtonStyle}
            onMouseEnter={e => {
                e.currentTarget.style.boxShadow = "0 8px 18px rgba(15, 23, 42, 0.16)";
                e.currentTarget.style.borderColor = "#94a3b8";
                e.currentTarget.style.transform = "translateY(-1px)";
            }}
            onMouseLeave={e => {
                e.currentTarget.style.boxShadow = "0 1px 2px rgba(15, 23, 42, 0.08)";
                e.currentTarget.style.borderColor = "#cbd5e1";
                e.currentTarget.style.transform = "translateY(0)";
            }}
        >
            Retour au planning
        </button>
    );
}

function ControleBisHeader({ service, view }) {
    const { creation, workspace } = view;
    return (
        <div style={pageHeaderStyle}>
            <div style={{ display: "flex", alignItems: "center", gap: "12px", minWidth: 0 }}>
                {workspace.activeDossier && <BackToPlanningButton />}
                <div style={{ minWidth: 0 }}>
                    <span style={eyebrowStyle}>Qualité PDA</span>
                    <h1 style={{ margin: "2px 0 0", fontSize: workspace.activeDossier ? "20px" : "24px", color: "#0f172a", letterSpacing: 0 }}>{service?.name || "Contrôle Bis"}</h1>
                    {!workspace.activeDossier && <div style={{ color: "#64748b", fontSize: "13px", marginTop: "4px" }}>
                        Fiches de contrôle PDA par EHPAD et date de production.
                    </div>}
                </div>
            </div>
            {!workspace.activeDossier && (
                <button type="button" onClick={creation.openCreateModal} style={createDossierButtonStyle}>
                    Création fiche de contrôle
                </button>
            )}
        </div>
    );
}

export default function ControleBis({ service = null }) {
    const view = useControleBis();
    const { chronic, controle, creation, editing, error, report, remainingPatientCount, workspace } = view;

    if (workspace.loading) {
        return <div style={{ padding: "28px", color: "#64748b" }}>Chargement du contrôle...</div>;
    }

    return (
        <div style={{ padding: "14px", background: theme.page, minHeight: "100%" }}>
            <PatientRowHoverStyle />
            <ControleBisHeader service={service} view={view} />

            {error && (
                <div style={{ marginBottom: "12px", padding: "10px 12px", background: "#fef2f2", color: "#991b1b", border: "1px solid #fecaca", borderRadius: "8px", fontSize: "13px" }}>
                    {error}
                </div>
            )}

            {renderActiveDossier(view)}
            {creation.showCreateModal && (
                <CreateDossierModal
                    ehpads={workspace.ehpads}
                    initialEhpadId={workspace.selectedEhpadId}
                    saving={workspace.saving}
                    onCancel={creation.closeCreateModal}
                    onCreate={creation.createDossier}
                />
            )}
            {renderValidatePreProductionConfirmModal(view)}
            {renderControlePatientModal(view)}
            <ControleDialogs
                workspace={workspace}
                controle={controle}
                editing={editing}
                chronic={chronic}
                report={report}
                remainingPatientCount={remainingPatientCount}
                overlayStyle={controleNestedModalOverlayStyle}
                idPrefix="controle-bis"
                identityZIndex={1250}
            />
        </div>
    );
}
